import { tabNavigationOutline, Text } from '@lojinha/design-system'
import { Plus } from '@lojinha/design-system/src/icons'
import { testId } from '@lojinha/helpers'
import React from 'react'
import styled, { css } from 'styled-components'
import { t } from '../../../dictionary'

type Props = {
  addItem: () => void
  isHover?: boolean
  isBlock?: boolean
  isSmall?: boolean
  isBig?: boolean
  ariaLabel: string
}

const addHoverStyle = css`
  ${({ theme }) => `
    color: ${theme.colors.white};
    background-color: ${theme.colors.success};
    border: 2px solid ${theme.colors.success};
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out,
      border 0.2s ease-in-out;

    svg {
      path {
        fill: ${theme.colors.white};
        transition: fill 0.2s ease-in-out;
      }
    }
  `}
`

const TextContainer = styled.div<{ isBlock?: boolean }>`
  width: auto;
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s ease 250ms, width 0.1s ease;

  ${({ isBlock }) =>
    !isBlock
      ? `
        width: 0;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s ease, width 0.1s ease;
      `
      : ''}
`

const AddButton = styled.div<{
  isHover?: boolean
  isBlock?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-transform: uppercase;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out,
    border 0.2s ease-in-out, width 0.2s ease;

  ${({ theme }) => `
    color: ${theme.colors.success};
    background-color: ${theme.colors.white};
    border: 2px solid ${theme.colors.success};
    border-radius: ${theme.space.x8};
    height: ${theme.space.x32};

    svg {
      path {
        fill: ${theme.colors.success};
        transition: fill 0.2s ease-in-out;
      }
    }
  `}

  ${({ isBlock }) => (!isBlock ? `justify-content: center;` : '')}


  ${({ isHover }) => (isHover ? addHoverStyle : '')}
`

const Wrapper = styled.button<{
  isBlock?: boolean
  isBig?: boolean
  isSmall: boolean
}>`
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${({ theme, isBlock, isBig, isSmall }) => `
    min-height: ${theme.space.x48};
    min-width: ${theme.space.x48};
    background-color: ${theme.colors.transparent};
    padding: ${isBig ? '0px' : theme.space.x8};
    width: ${isBlock ? '100%' : isBig ? theme.space.x72 : theme.space.x48};
    transition: width 0.2s ease;
    
    ${AddButton} {
      width: ${isBlock ? '100%' : isBig ? theme.space.x72 : theme.space.x32};
      height: ${isBig ? theme.space.x48 : ''};
    }

    ${
      isSmall
        ? ''
        : `
        ${theme.media.above('md')}{
          width: ${
            isBlock ? '100%' : isBig ? theme.space.x72 : theme.space.x88
          };
          
          ${AddButton} {
            width: 100%;
          }
        }
      `
    }
  `}

  &:hover {
    ${AddButton} {
      ${addHoverStyle}
    }
  }

  &:focus:not(:focus-visible) {
    ${AddButton} {
      outline: none;
    }
  }

  &:focus-visible {
    ${AddButton} {
      ${tabNavigationOutline}
    }
  }
`

export const AddButtonUI = ({
  addItem,
  isHover,
  isBlock,
  isSmall = false,
  ariaLabel,
  isBig = false,
}: Props) => {
  return (
    <Wrapper
      aria-label={ariaLabel}
      isBlock={isBlock}
      isSmall={isSmall}
      isBig={isBig}
      onClick={addItem}
      {...testId('add-to-cart-button-vitrine')}
    >
      <AddButton isBlock={isBlock} isHover={isHover}>
        <Plus />
        <TextContainer isBlock={isBlock}>
          <Text textAlign="center" textSize="x1" isBold>
            {t.add}
          </Text>
        </TextContainer>
        {isBlock && <div />}
      </AddButton>
    </Wrapper>
  )
}
